document.addEventListener("DOMContentLoaded",function(){
    let infoDataObj = {
        mobileFJval:768, //   切换移动端的 屏幕宽度
        innerHeight: window.innerHeight, 
        zwHeight: window.innerHeight,//  动画 一屏一屏高度的值
        returnInnerHeight(){
            this.innerHeight = window.innerHeight;
            this.zwHeight = window.innerHeight > 750 ? (window.innerHeight > 1000 ? 1000 : window.innerHeight) : 750;
        },
        returnMinNumFn(a,b){
            let num = Math.min(a, b);
            return num
        },
        init(){
            this.positionFn();
            this.initSeriesSwiper();// series
            this.listenerDetailsFn();// details
            this.initVideoScroll(); // 横滚视频监听
            this.ga4TrackAddClick(); // ga4
            if(document.querySelector('.ug-genshin-tjdiv')){
                this.initTJSwiper(); // pro tj
            }
            // gsap
            gsap.registerPlugin(ScrollTrigger);
            let mm = gsap.matchMedia();
            mm.add(`(min-width: ${this.mobileFJval + 1}px)`, () => {
               // desktop setup code here...
                setTimeout(()=>{
                    this.gsapPCFn();
                    this.gsapCommonFn();
                },0);
            });

            mm.add(`(max-width: ${this.mobileFJval}px)`, () => {
                // mobile setup code here...
                setTimeout(()=>{
                    this.gsapMobileFn();
                    this.gsapCommonFn();
                },0);
            });

            var resizeTimer = null;
            window.addEventListener("resize", ()=>{
                if(resizeTimer){
                    clearTimeout(resizeTimer);
                }
                resizeTimer = setTimeout(()=>{
                    // 清除现有的所有 ScrollTrigger 实例
                    ScrollTrigger.getAll().forEach(trigger => trigger.kill());
                    // 用于针对不同屏幕尺寸定义动画，并确保在屏幕尺寸变化时自动更新
                    gsap.matchMediaRefresh(); 
                    setTimeout(()=>{
                        // 确保所有 ScrollTrigger 的起点和终点在窗口尺寸变化时正确刷新
                        ScrollTrigger.refresh(true);
                    },0); 
                },300);
            });
        },
        positionFn(){
            // 定位跳转
            let clickList = document.querySelectorAll('.ug-genshin-position');
            clickList.forEach((item,index)=>{
                item.addEventListener('click',()=>{
                    let scrollDiv = item.getAttribute('data-scrolldiv');
                    scrollDiv = document.querySelector(`.${scrollDiv}`);
                    if(!scrollDiv){
                        return false;
                    }
                    let cjJL = 0;
                    if(window.innerWidth > 768){
                        if(item.getAttribute('data-pcJL')){
                            cjJL = item.getAttribute('data-pcJL');
                        }
                    }else{
                        if(item.getAttribute('data-moJL')){
                            cjJL = item.getAttribute('data-moJL');
                        }
                    }
        
                    let scrolljl = document.documentElement.scrollTop || document.body.scrollTop;
                    let contentScrollJL = 0;
                    contentScrollJL = scrollDiv.getBoundingClientRect().top - cjJL + scrolljl  - 10 + 1;
                    if(contentScrollJL <= 0){
                        contentScrollJL = 0;
                    }
                    window.scrollTo({
                        top: contentScrollJL,
                        behavior: "smooth"
                    });
                });
            });
        },
        ga4TrackAddClick(){
            let buttonList = document.querySelectorAll('.ug-genshin-button-ga4');
            buttonList.forEach((item,key)=>{
                if(!window.ugGa4Track){
                    return false;
                }
                // ga4ButtonName button：功能描述
                item.addEventListener('click',()=>{
                    //ga4ButtonName button：功能描述
                    let ga4ButtonName = item.getAttribute('data-ga4ButtonName');
                    window.ugGa4Track.clickEvent({button_name: ga4ButtonName, position: `genshin`});
                    console.log("ga4TrackAddClick!!!!!!!!!!!!",ga4ButtonName);
                });
            });
        },
        // series
        initSeriesSwiper() {
            new Swiper('.ug-genshin-series_slider', {
              direction: 'horizontal',
              threshold: 30, // 超过30px才算做滑动
              initialSlide: 0,
              slidesPerView: 'auto',
              spaceBetween: 12,
              centeredSlides: true,
              breakpoints: {
                768: {
                  spaceBetween: 20,
                  centeredSlides: false,
                }
              },
              navigation: {
                nextEl: '.ug-genshin-seriesdiv .swiper-button-next',
                prevEl: '.ug-genshin-seriesdiv .swiper-button-prev',
              }
            });
        },
        // series end

        // pro 推荐
        initTJSwiper() {
            new Swiper('.ug-genshin-tj_slider', {
            direction: 'horizontal',
            threshold: 30, // 超过30px才算做滑动
            initialSlide: 0,
            slidesPerView: 'auto',
            spaceBetween: 40,
            centeredSlides: false,
            navigation: {
                nextEl: '.ug-genshin-tjdiv .swiper-button-next',
                prevEl: '.ug-genshin-tjdiv .swiper-button-prev',
            }
            });
        },
        // pro 推荐 end

        // 横滚视频监听
        initVideoScroll(){
            let videoList = document.querySelectorAll('.ug-genshin-journey-video-divflex .ug-genshin-journey-video-item video')
            videoList.forEach((item,key)=>{
                // 播放开始事件
                item.addEventListener('play', () => {
                    let index = item.getAttribute('data-index');
                    document.querySelector(`.ug-genshin-journey-video-divflex .ug-genshin-journey-video-item${index}`).setAttribute('data-status', 'play');
                });

                // 暂停事件
                item.addEventListener('pause', () => {
                    let index = item.getAttribute('data-index');
                    document.querySelector(`.ug-genshin-journey-video-divflex .ug-genshin-journey-video-item${index}`).setAttribute('data-status', 'paused');
                });

                // 播放结束事件
                item.addEventListener('ended', () => {
                    let index = item.getAttribute('data-index');
                    document.querySelector(`.ug-genshin-journey-video-divflex .ug-genshin-journey-video-item${index}`).setAttribute('data-status', 'ended');
                });
            });

            // icon
            let videoIconList = document.querySelectorAll('.ug-genshin-journey-video-divflex .ug-genshin-journey-videoFn');
            videoIconList.forEach((item,key)=>{
                item.addEventListener('click',function(){
                    let index = this.getAttribute('data-index');
                    let status = this.getAttribute('data-status');
                    let video = document.querySelector(`.ug-genshin-journey-video-divflex .ug-genshin-journey-video-item${index} video`);
                    if(status == 'play'){
                        video.play();
                    }else if(status == 'paused'){
                        video.pause();
                    }else if(status == 'replay'){
                        video.currentTime = 0;
                        video.play();
                    }
                });
            })

        },
        // 横滚视频监听 end

        // 细节
        listenerDetailsFn(){
            // 点击切换展示
            let detailsList = document.querySelectorAll('.ug-genshin-local-details-control');
            detailsList.forEach((item,key)=>{
                item.addEventListener('click',function(){
                    let index = this.getAttribute('data-index');
                    document.querySelectorAll('.ug-genshin-local-details-item').forEach((item)=>{
                        item.classList.remove('active');
                        item.classList.remove('toAnimate');
                    });
                    document.querySelectorAll('.ug-genshin-local-details-control').forEach((item)=>{
                        item.classList.remove('active');
                    });

                    if(document.querySelector(`.ug-genshin-local-details-control[data-index="${index}"]`)){
                        document.querySelectorAll(`.ug-genshin-local-details-control[data-index="${index}"]`).forEach((item)=>{
                            item.classList.add('active');
                        });
                    }

                    if(document.querySelector(`.ug-genshin-local-details-item${index}`)){
                        document.querySelectorAll(`.ug-genshin-local-details-item${index}`).forEach((item)=>{
                            item.classList.add('active');
                            if(item.classList.contains('ug-genshin-local-details-item1')){
                                item.classList.add('isNoFirst');
                                item.querySelector('video').play();
                                return false;
                            }
                            setTimeout(() => {
                                item.classList.add('toAnimate');
                            }, 10);
                        });
                    }
                    
                });
            });

            // 鼠标经过 购买模块 pc
            let detailsBuyList= document.querySelectorAll('.ug-genshin-local-details-big .ug-genshin-local-details-item-buy');
            detailsBuyList.forEach(item => {
                const bElement = item.querySelector('.ug-genshin-local-details-item-buy-cont');
                
                item.addEventListener('mouseenter', function() {
                  bElement.style.display = 'block';  // 鼠标经过时显示子元素
                });
              
                item.addEventListener('mouseleave', function() {
                  bElement.style.display = 'none';  // 鼠标移开时隐藏子元素
                });
            });

            // 第一个模块 视频播放 展示后续的动效
            let videoDom = document.getElementById('ug-genshin-local-details-item1-video');
            // 监听视频播放完毕的 'ended' 事件
            videoDom.addEventListener('ended', function() {
                document.querySelector('.ug-genshin-local-details-item1').classList.add('toAnimate');
                // 在这里你可以执行其他操作，比如提示用户视频结束、切换到另一个视频等
            });
        },
        detailVideoFn(){
            let details_item1 = document.querySelector('.ug-genshin-local-details-item1')
            if(details_item1.classList.contains('active') && !details_item1.classList.contains('isNoFirst')){
                details_item1.classList.add('isNoFirst');
                details_item1.querySelector('video').currentTime = 0;
                details_item1.querySelector('video').play();
            }
        },
        // 细节 end
        // 隐藏 头尾的导航
        hideNavFn(){
            document.querySelector('.ug-genshin-nav-fixed').classList.add('ug-genshin-zIndx-zh');
            document.querySelector('.ug-genshin-pre-xfkdiv').classList.add('ug-genshin-zIndx-zh');
        },
        // 显示 头尾的导航
        showNavFn(){
            document.querySelector('.ug-genshin-nav-fixed').classList.remove('ug-genshin-zIndx-zh');
            document.querySelector('.ug-genshin-pre-xfkdiv').classList.remove('ug-genshin-zIndx-zh');
        },
        // gsap 动画
        gsapPCFn(){
            if(document.querySelector('.ug-genshin-journeyAll').classList.contains('ug-genshin-journeyAll-hasAnimate')){
                // 一图懂 卡屏
                gsap.timeline({
                    scrollTrigger:{
                        trigger: '.ug-genshin-sell_pointflex',
                        start:`center center`,
                        end:`+=800px`,
                        pin: true,
                        scrub: 1, // 动画与滚动同步
                        onEnter:()=>{
                            document.querySelector('.ug-genshin-sell-scale-ab').classList.add('opacity1');
                        },
                        onLeaveBack:()=>{
                            document.querySelector('.ug-genshin-sell-scale-ab').classList.remove('opacity1');
                        }
                    }
                });
                // 放大后的卡屏
                gsap.timeline({
                    scrollTrigger:{
                        trigger: '.ug-genshin-journeyAll',
                        start:"top top",
                        end:`+=300px`,
                        pin: true,
                        scrub: 1, // 动画与滚动同步
                    }
                });
            }

        
            // 横滚视频的卡屏
            let journey_video_jl = document.querySelector('.ug-genshin-journey-video-divflex-inb').clientWidth - document.querySelector('.ug-genshin-journey-video-item').clientWidth;
            let journey_video_parent_left = document.querySelector('.ug-genshin-journey-video-div .ug-genshin-maxw').getBoundingClientRect().left;
            let journey_video_list = document.querySelectorAll('.ug-genshin-journey-video-div .ug-genshin-journey-video-item');
            let pinExtension = 150 // 附加固定区域
            gsap.timeline({
                scrollTrigger: {
                    trigger: '.ug-genshin-journey-video-div',
                    start: 'center center', 
                    end: `+=${journey_video_jl + 1 + pinExtension}px`,//'+=1500px',
                    pin: true,
                    pinSpacing: true, // 确保pin元素周围有正确的空间
                    scrub: 1,
                    anticipatePin: 1, // 提前准备pin，使过渡更平滑
                    onUpdate:()=>{
                        let index = -1;
                        journey_video_list.forEach((item,key)=>{
                            if(item.getBoundingClientRect().left >0 && item.getBoundingClientRect().left <= journey_video_parent_left){
                                index = key+1;
                            }
                        });
                        if(index == -1){
                            return false;
                        }
                        let nowDom = document.querySelector(`.ug-genshin-journey-video-div .ug-genshin-journey-video-item${index}`)
                        if( nowDom  && ! nowDom.classList.contains('active')){
                            journey_video_list.forEach((item,key)=>{
                                item.classList.remove('active');

                                item.querySelector('video').pause();
                                item.querySelector('video').currentTime = 0;
                            });
                            nowDom.classList.add('active');
                            nowDom.querySelector('video').play();
                        }

                    }
                }
            })
            .to('.ug-genshin-journey-video-divflex-inb', {
                x: `-${journey_video_jl + 1}px`,//'-1500px',
                ease: 'none'
            })
            .to({}, { // 空动画用于延长pin区域
                    duration: pinExtension / 1000 
            });
            // 卡屏end

            // 细节
            gsap.to(".ug-genshin-local-details-div",{
                scrollTrigger: {
                    trigger: ".ug-genshin-local-details-div",
                    scrub: true,
                    start: "center center",
                    end: "+=100px",
                    //immediateRender: false //禁止动画在初始化时立即执行
                    onEnter:()=>{
                        this.detailVideoFn();
                    },
                    onEnterBack:()=>{
                        this.detailVideoFn();
                    }
                }
            });
            // 细节 end
            
            if(document.querySelector('.ug-genshin-journeyAll').classList.contains('ug-genshin-journeyAll-hasAnimate')){
                // 一图懂的放大
                gsap.to(".ug-genshin-sell-scale-ab",{
                    scrollTrigger: {
                        trigger: ".ug-genshin-sell_pointflex",
                        scrub: true,
                        start: "center center",
                        end: `+=400px`
                    },
                    width: "2560px",
                    height: "1188px",
                    ease: "none"
                })
                gsap.to("#ug-genshin-sell-scale-img",{
                    scrollTrigger: {
                        trigger: ".ug-genshin-sell_pointflex",
                        scrub: true,
                        start: "center center",
                        end: `+=400px`,
                    },
                    width: "2560px",
                    height: "1188px",
                    x:0, y:0,
                    ease: "none"
                });
                gsap.to(".ug-genshin-sell-scale-pr",{
                    scrollTrigger: {
                        trigger: ".ug-genshin-sell_pointflex",
                        scrub: true,
                        start: "center center",
                        end: `+=400px`,
                    },
                    y:`10.5%`,
                    x:`-0.18%`,
                    ease: "none"
                });
                

                // 一图懂后的显示
                gsap.to(".ug-genshin-journeyAll",{
                    scrollTrigger: {
                        trigger: ".ug-genshin-journeyAll",
                        scrub: true,
                        start: "top top",
                        end: `+=100%`,
                        onEnter:()=>{
                            document.querySelector('.ug-genshin-journeyAll').classList.remove('opacity0');
                            if(document.querySelector('.ug-genshin-journeyAll').classList.contains('ug-genshin-journeyAll-hasAnimate')){
                                infoDataObj.showNavFn();
                            }
                        },
                        onLeaveBack:()=>{
                            document.querySelector('.ug-genshin-journeyAll').classList.add('opacity0');
                            if(document.querySelector('.ug-genshin-journeyAll').classList.contains('ug-genshin-journeyAll-hasAnimate')){
                                infoDataObj.hideNavFn();
                            }
                        }
                    }
                });
            }
            // 一图懂  一个一个展示
            gsap.to(".ug-genshin-sell_point-animate1", {
                scrollTrigger: {
                    trigger: ".ug-genshin-sellpoint .ug-genshin-maxw",
                    scrub: true,
                    start: "center 85%",
                    end: "center 80%",
                    onEnter:()=>{
                        if(document.querySelector('.ug-genshin-journeyAll').classList.contains('ug-genshin-journeyAll-hasAnimate')){
                            infoDataObj.hideNavFn();
                        }
                    },
                    onLeaveBack:()=>{
                        if(document.querySelector('.ug-genshin-journeyAll').classList.contains('ug-genshin-journeyAll-hasAnimate')){
                            infoDataObj.showNavFn();
                        }
                    }
                },
                opacity: 1,
                ease: "none"
            });
            gsap.to(".ug-genshin-sell_point-animate2", {
                scrollTrigger: {
                    trigger: ".ug-genshin-sellpoint .ug-genshin-maxw",
                    scrub: true,
                    start: "center 80%",
                    end: "center 75%"
                },
                opacity: 1,

                ease: "none"
            });
            gsap.to(".ug-genshin-sell_point-animate3", {
                scrollTrigger: {
                    trigger: ".ug-genshin-sellpoint .ug-genshin-maxw",
                    scrub: true,
                    start: "center 75%",
                    end: "center 70%"
                },
                opacity: 1,
                ease: "none"
            });
            gsap.to(".ug-genshin-sell_point-animate4", {
                scrollTrigger: {
                    trigger: ".ug-genshin-sellpoint .ug-genshin-maxw",
                    scrub: true,
                    start: "center 70%",
                    end: "center 65%"
                },
                opacity: 1,
                ease: "none"
            });
            gsap.to(".ug-genshin-sell_point-animate5", {
                scrollTrigger: {
                    trigger: ".ug-genshin-sellpoint .ug-genshin-maxw",
                    scrub: true,
                    start: "center 65%",
                    end: "center 60%"
                },
                opacity: 1,
                ease: "none"
            });
            gsap.to(".ug-genshin-sell_point-animate6", {
                scrollTrigger: {
                    trigger: ".ug-genshin-sellpoint .ug-genshin-maxw",
                    scrub: true,
                    start: "center 60%",
                    end: "center 55%"
                },
                opacity: 1,
                ease: "none"
            });
            gsap.to(".ug-genshin-sell_point-animate7", {
                scrollTrigger: {
                    trigger: ".ug-genshin-sellpoint .ug-genshin-maxw",
                    scrub: true,
                    start: "center 55%",
                    end: "center 50%"
                },
                opacity: 1,
                ease: "none"
            });
            // 一图懂  一个一个展示 end

            // 宣传视频 放大缩小
            let video_w = document.querySelector('.ug-genshin-video-pr').clientWidth;
            gsap.to(".ug-genshin-video-animateDiv",{
                scrollTrigger: {
                    trigger: ".ug-genshin-video-pr",
                    scrub: true,
                    start: "center 100%",
                    end: "center 65%",
                    // markers:true,
                    //immediateRender: false //禁止动画在初始化时立即执行
                    onLeave:()=>{
                        document.querySelector('.ug-genshin-video-waipr')?.classList.add('showBorder');
                    },
                    onEnterBack:()=>{
                        document.querySelector('.ug-genshin-video-waipr')?.classList.remove('showBorder');
                    }
                },
                width: `${video_w}px`,
                ease: "none"
            });

            //  场景图 放大缩小
            let map_scale = (document.querySelector('.ug-genshin-map-cont').clientWidth - 20) / document.querySelector('.ug_genshin_map').clientWidth;
            console.log(map_scale);
            let map_imt_top = document.querySelector('.action_slider').offsetTop;
            // document.querySelector('.ug-genshin-map-imgab').style.transformOrigin = `center ${map_imt_top}px`
            gsap.to(".ug-genshin-map-imgab",{
                scrollTrigger: {
                    trigger: ".ug_genshin_mapDiv",
                    scrub: true,
                    start: "center 100%",
                    end: "center 65%",
                    //immediateRender: false //禁止动画在初始化时立即执行
                    onLeave:()=>{
                        document.querySelector('.ug_genshin_map')?.classList.add('showCont');
                    },
                    onEnterBack:()=>{
                        document.querySelector('.ug_genshin_map')?.classList.remove('showCont');
                    }
                },
                scale: `${map_scale} ${map_scale}`,
                y: `${map_imt_top}px`,
                ease: "none"
            });

            // 场景图 出字
            gsap.to(".ug-genshin-map-title",{
                scrollTrigger: {
                    trigger: ".ug_genshin_mapDiv",
                    scrub: true,
                    start: "center 85%",
                    end: "center 65%",
                    // markers:true,
                },
                opacity: 1,
                y: `0px`,
                ease: "none"
            });
            gsap.to(".action_title",{
                scrollTrigger: {
                    trigger: ".ug_genshin_mapDiv",
                    scrub: true,
                    start: "center 75%",
                    end: "center 65%",
                },
                opacity: 1,
                y: `0px`,
                ease: "none"
            });
            // 场景图 放大缩小 end
        },
        gsapMobileFn(){
            // 横滚视频 平铺 到中间就播放
            document.querySelectorAll(".ug-genshin-journey-video-item").forEach((item,index)=>{
                gsap.to(item,{
                    scrollTrigger: {
                        trigger: item,
                        scrub: true,
                        start: "center center",
                        end: "+=100px",
                        //immediateRender: false //禁止动画在初始化时立即执行
                        onEnter:(item)=>{
                            document.querySelectorAll(".ug-genshin-journey-video-item").forEach((v)=>{
                                v.classList.remove('active');
                                v.querySelector("video").pause();
                                v.querySelector("video").currentTime = 0;
                            });
                            item.trigger.classList.add('active');
                            item.trigger.querySelector("video").play();
                        },
                        onEnterBack:(item)=>{
                            document.querySelectorAll(".ug-genshin-journey-video-item").forEach((v)=>{
                                v.classList.remove('active');
                                v.querySelector("video").pause();
                                v.querySelector("video").currentTime = 0;
                            });
                            item.trigger.classList.add('active');
                            item.trigger.querySelector("video").play();
                        }
                    }
                });
            });
            // 横滚视频 平铺 到中间就播放end

            // 细节
            gsap.to(".ug-genshin-local-details-div",{
                scrollTrigger: {
                    trigger: ".ug-genshin-local-details-div",
                    scrub: true,
                    start: "center center",
                    end: "+=100px",
                    //immediateRender: false //禁止动画在初始化时立即执行
                    onEnter:()=>{
                        this.detailVideoFn();
                    },
                    onEnterBack:()=>{
                        this.detailVideoFn();
                    }
                }
            });
            // 细节 end
            
        },
        gsapCommonFn(){
            if(document.querySelector(".ug-genshin-nav")){
                gsap.timeline({
                    scrollTrigger: {
                        trigger: '.ug-genshin-nav-relative',
                        start: `top top`,  // 页面滚动到该模块的顶部时开始
                        end: `+=100%`,
                        scrub: 1,  // 动画与滚动同步
                        onEnter: () => {
                          document.querySelector(".ug-genshin-nav-fixed").classList.remove('dpn');
                        },
                        onLeaveBack: () => {
                          document.querySelector('.ug-genshin-nav-fixed').classList.add('dpn');
                        }
                    }
                });
            }
            gsap.timeline({
                scrollTrigger:{
                    trigger: '.ug-genshin-pre-xfkpr',
                    start:`bottom bottom`,
                    end:`+=100%`,
                    scrub: 1, // 动画与滚动同步
                    anticipatePin: 1, //参数提升滚动预判精度
                    onEnter:()=>{
                        document.querySelector('.ug-genshin-pre-fixed').classList.add('dpn');
                    },
                    onLeaveBack:()=>{
                        document.querySelector('.ug-genshin-pre-fixed').classList.remove('dpn');
                    }
                }
            });
        }

    }
    infoDataObj.init();
});